import axios from '@/lib/axios';
import {
  Blog,
  BlogListResponse,
  BlogResponse,
} from '../types/blog.type';
import { HttpService } from '@/services/http';

const BASE_URL = '/blogs';

export const blogService = {

  async getBlogs(params?: { page?: number; limit?: number; search?: string }) {
    return HttpService.getPaginated<Blog>(BASE_URL, params);
  },

  getBlogBySlug: async (slug: string) => {
    const { data } = await axios.get<BlogResponse>(
      `${BASE_URL}/${slug}`
    );
    return data;
  },

  getBlogById: async (id: string) => {
    const { data } = await axios.get<BlogResponse>(
      `${BASE_URL}/id/${id}`
    );
    return data;
  },
  create: async (formData: FormData) => {
    return HttpService.post<Blog>(BASE_URL, formData);
  },
};